import { render, staticRenderFns } from "./CardUser.vue?vue&type=template&id=25c72592"
import script from "./CardUser.vue?vue&type=script&lang=js"
export * from "./CardUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports